import React, { ReactNode } from 'react'
import debug from 'debug'

import { findOneByName } from '@s4l/utils/library/react'

import { IconInfoMsg } from '@s4l/icons/IconInfoMsg'
import { IconWarningMsg } from '@s4l/icons/IconWarningMsg'
import { IconErrorMsg } from '@s4l/icons/IconErrorMsg'
import { IconSuccessMsg } from '@s4l/icons/IconSuccessMsg'
import { IconClose } from '@s4l/icons/IconClose'

import { Title } from './Title'
import { Body } from './Body'
import Button from '../Button'

import styles from './index.module.css'

const log = debug('s4l:ds:MessageBox')

interface IMessageBox {
  kind: 'info' | 'warning' | 'success' | 'error' | 'neutral'
  children: ReactNode
  icon?: ReactNode
  onClose?: () => void
}

const Icons = {
  info: <IconInfoMsg data-testid="icon" />,
  warning: <IconWarningMsg data-testid="icon" />,
  error: <IconErrorMsg data-testid="icon" />,
  success: <IconSuccessMsg data-testid="icon" />,
  neutral: null,
}

function MessageBox(props: Readonly<IMessageBox>) {
  const { kind, icon, onClose, children } = props

  const TitleInternal = findOneByName(children, 'MessageBox.Title')
  if (!TitleInternal) {
    log('MessageBox.Title is required')
    return null
  }

  const BodyInternal = findOneByName(children, 'MessageBox.Body')

  return (
    <div data-kind={kind} className={styles.container}>
      <div className={styles.content}>
        <div className={styles.body}>
          <div className={styles.title}>
            {icon || Icons[kind]}
            {TitleInternal}
          </div>
          {BodyInternal}
        </div>
        {onClose && (
          <Button variant="text-flat" onClick={onClose}>
            <div className={styles.iconContainer}>
              <IconClose size={24} />
            </div>
          </Button>
        )}
      </div>
    </div>
  )
}

MessageBox.Title = Title
MessageBox.Body = Body

export default MessageBox
